module.exports = __webpack_public_path__ + "img/icon-copylink.ceff40cb.png";